module.exports = __webpack_public_path__ + "img/maintenance-arrivals_purple.84013be8.svg";